import { ReactNode } from 'react';

import { ChangePasswordFormDataType, PersonalInfoSchemaType } from '@/schemas';
import { AxiosBaseResponse } from '@/types/common';

export interface GetPersonalSettingsSuccessResponse extends AxiosBaseResponse {
  data: PersonalInfoSchemaType;
}

export interface SavePersonalSettingsRequest {
  first_name: string;
  last_name: string;
}

export type ChangePasswordRequest = Omit<
  ChangePasswordFormDataType,
  'confirm_password'
>;

export type TCurrency = 'usd' | 'gbp' | 'eur';
export type TCurrencySign = '$' | '£' | '€';

export interface PricingPlanDetails {
  plan_name: string;
  month_amount: number;
  currency: TCurrency;
  currency_sign: TCurrencySign;
  string_amount: string;
}

export interface GetPricingPlanSuccessResponse extends AxiosBaseResponse {
  data: PricingPlanDetails;
}

export interface SavePricingPlanRequest {
  userId: string;
  data: PricingPlanDetails;
}

export interface ChannelDetails {
  channel_id: DataSourceType;
  active: boolean;
  address?: string;
}

export interface GetConnectedChannelsSuccessResponse extends AxiosBaseResponse {
  data: Array<ChannelDetails>;
}

export interface TaskResponse {
  id: string;
  status: string;
}

export interface IDataSourceInstance {
  id: string;
  url: string;
}

export interface ISocialDataSourceInstance extends IDataSourceInstance {
  dataSourceType: DataSourceType;
  icon?: ReactNode;
  color?: string;
}

export const DataSourceType = {
  WEBSITE: 'WEBSITE',
  LINKEDIN: 'LINKEDIN',
  INSTAGRAM: 'INSTAGRAM',
  FACEBOOK: 'FACEBOOK',
} as const;

export type DataSourceType =
  (typeof DataSourceType)[keyof typeof DataSourceType];

export const SocialMediaType = {
  Linkedin: 'LINKEDIN',
  Instagram: 'INSTAGRAM',
  Facebook: 'FACEBOOK',
} as const;

export type SocialMediaType =
  (typeof SocialMediaType)[keyof typeof SocialMediaType];

export interface SettingsDetails {
  created: string;
  id: string;
  site_type: DataSourceType;
  status: 'DONE';
  url: string;
}

export interface SocialsTokenDetails {
  id: string;
  created: string;
  social_media_type: string;
  is_active: boolean;
  expires: string;
  status: string;
}
export interface SocialMediaAuthReponse extends AxiosBaseResponse {
  data: {
    auth_url: string;
  };
}

export interface SocialsTokenResponse extends AxiosBaseResponse {
  data: Array<SocialsTokenDetails>;
}

export interface GetWikiSettingsResponse extends AxiosBaseResponse {
  data: Array<SettingsDetails>;
}

export interface UpdateWikiSettingsResponse extends AxiosBaseResponse {
  data: SettingsDetails & { task?: TaskResponse };
}

export interface SocialMediaAuthResponse extends AxiosBaseResponse {
  data: SocialMediaAuthReponse;
}
